module.exports = __webpack_public_path__ + "static/img/zijianbusiness.4edf34d6.jpg";